import { ReactNode, useState } from 'react';
import { UnsavedChangesDialog } from './UnsavedChangesDialog';

interface UseConfirmationDialogParams {
    onConfirm: () => void;
    unsavedChangesContent?: ReactNode | null;
}

export const useConfirmationDialog = ({ onConfirm, unsavedChangesContent }: UseConfirmationDialogParams) => {
    const [isDialogOpened, setIsDialogOpened] = useState(false);

    const openConfirmationDialog = () => {
        setIsDialogOpened(true);
    };

    const handleCancel = () => {
        setIsDialogOpened(false);
    };

    const handleConfirm = () => {
        onConfirm();
        setIsDialogOpened(false);
    };

    const confirmationDialog = (
        <UnsavedChangesDialog
            active={isDialogOpened}
            content={unsavedChangesContent}
            onCancel={handleCancel}
            onDiscardChanges={handleConfirm}
        />
    );

    return {
        openConfirmationDialog,
        confirmationDialog,
    };
};
